export default __webpack_public_path__ + "static/media/book.600ff157.svg";